const key = {
  ENTER: 13,
  ESC: 27
}

export default {
  key
}



// WEBPACK FOOTER //
// ./src/utils/const.js